import { customElement, useView } from 'aurelia-templating';
import { widget } from '../widget-decorator';
import { BindingEngine } from 'aurelia-binding';
import { WidgetBase } from '../widget-base';
import { CustomerService } from '../../services/customer-service';
import { PLATFORM } from 'aurelia-framework';
import { property } from '../property-decorator';
import { WidgetPropertyType } from '../widget-property-type';

@customElement('current-date-widget')
@useView(PLATFORM.moduleName('./current-date-widget.html'))
@widget({ name: 'Current date', canUseInReport: true, canUseInDashboard: true, defaultWidth: 27, defaultHeight: 12 })
export class CurrentDateWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, bindingEngine: BindingEngine) {
    super(element, bindingEngine, customerService);
    this.title = 'Current date:';
    this.titleFontSize = 14;
  }

  date = new Date();

  @property('Text')
  font?: string;

  @property('Text')
  fontSize?: number = 24;

  @property('Text')
  color?: string;

  @property('Text', 'Alignment', WidgetPropertyType.List, [{ value: 'left', label: 'Left' }, { value: 'center', label: 'Center' }, { value: 'right', label: 'Right' }])
  textAlign?: 'left' | 'center' | 'right';

}
